import { render, staticRenderFns } from "./ExpertRegions.vue?vue&type=template&id=57525c3a&lang=pug&"
import script from "./ExpertRegions.vue?vue&type=script&lang=js&"
export * from "./ExpertRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports